export default "__VITE_ASSET__DmemtDKk__"